import { graphql } from 'gatsby';

import BlogDetail from 'components/BlogPost/BlogDetail';
import ScrollTracker from 'components/BlogPost/ScrollTracker';
import ResourceHero from 'components/ResourceComponents/ResourceHero';

import Layout from 'layouts/Layout';
import LayoutSection from 'layouts/LayoutSection';
import SEO from 'layouts/SEO';

import { minutesToRead } from 'utils/timeToRead';

import type { HeadFC, PageProps } from 'gatsby';
import type { ContentfulLayoutSection, ContentfulTemplateBlogPost } from 'graphqlTypes';
import type { FC } from 'react';

interface BlogData {
  blogData: ContentfulTemplateBlogPost;
  blogPostCardDeckSection: ContentfulLayoutSection;
}

const Blog: FC<PageProps<BlogData>> = ({ data: { blogData, blogPostCardDeckSection }, location: { href } }) => {
  const { title, publishDate, excerpt, author, featuredImage, body, category } = blogData;
  const readTime = minutesToRead(body || {});

  const breadcrumbs = [
    { label: 'Blog', link: '/blog' },
    { label: title || '', link: '' },
  ];

  const heroData = {
    breadcrumbs,
    href,
    readTime,
    title,
    excerpt: excerpt?.excerpt,
    publishDate,
    author,
    featuredReference: featuredImage,
    category: category?.name,
  };

  return (
    <Layout>
      <ScrollTracker />
      <ResourceHero {...heroData} />
      <BlogDetail readTime={readTime} {...blogData} />
      {blogPostCardDeckSection && <LayoutSection key={blogPostCardDeckSection.id} {...blogPostCardDeckSection} />}
    </Layout>
  );
};

export default Blog;

export const Head: HeadFC<BlogData> = ({
  data: {
    blogData: { seo, author },
  },
  location: { pathname },
}) => <SEO pathname={pathname} author={author} {...seo} />;

export const blogQuery = graphql`
  query templateBlogPostQuery($slug: String!) {
    blogData: contentfulTemplateBlogPost(slug: { eq: $slug }) {
      ...contentfulTemplateBlogPost
    }
    blogPostCardDeckSection: contentfulLayoutSection(contentful_id: { eq: "4tEHGNwCAidZ1MkL2Uwrhv" }) {
      ...contentfulLayoutSection
    }
  }
`;
